import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "TopicAnnotations" */ './lazyIndex')
);

// Interfaces
export * from './store/schema/TopicAnnotationApi';

// Utils
export { getTopicsSdk } from './utils/topicsSdk';

// Lazy utils
export const lazyGetTopicDefinition = new LazyImport(lazyModule, m => m.getTopicDefinition);
export const lazyGetTopicAnnotations = new LazyImport(lazyModule, m => m.getTopicAnnotations);
export const lazyAddTopic = new LazyImport(lazyModule, m => m.addTopic);
export const lazyInitializeTopicsSdk = new LazyImport(lazyModule, m => m.initializeTopicsSdk);
